import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import ModalBootstrap from 'react-bootstrap/Modal'
import { X } from 'react-feather'

const headerStyle = {
  flex: '1 1 auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: '20px',
  fontWeight: 'semibold',
  color: '#FFF',
  padding: '12px',
}

const ExitButton = styled.button`
  border: 0;
  background-color: inherit;
  display: flex;
  justify-content: center;
  color: inherit;
  svg {
    opacity: 0.5;
  }
  :hover {
    transition: 200ms ease-in-out;
    svg {
      opacity: 1;
    }
  }
  :focus {
    border: 0;
    outline: 0;
    svg {
      opacity: 1;
    }
  }
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

interface ModalProps {
  body: React.ReactNode
  title: string
  headerBackgroundColor?: string
  size?: 'sm' | 'lg' | 'xl'
  style?: any
  bodyStyle?: any
  show: boolean
  closedButton?: boolean
  centered?: boolean
  closeButtonAction?: any
  titleStyle?: any
  onHide?: any
  IconLeft?: () => JSX.Element
  styleHeader?: React.CSSProperties
  dialogClassName?: string
  testId?: string
  closeButtonDisabled?: boolean
  zIndex?: number
}

function Modal({
  body,
  title,
  headerBackgroundColor = '#002D62',
  size,
  style = {},
  bodyStyle = {},
  titleStyle = {},
  show = false,
  closedButton = true,
  centered = false,
  closeButtonAction = () => ({}),
  onHide = () => ({}),
  IconLeft,
  styleHeader = {},
  dialogClassName = undefined,
  testId,
  closeButtonDisabled = false,
  zIndex = 1040,
}: ModalProps) {
  const [isShow, setIsShow] = useState(show)

  useEffect(() => {
    setIsShow(show)
  }, [show])

  const handleIsShow = () => setIsShow((prevState) => !prevState)

  return (
    <ModalBootstrap
      show={isShow}
      backdrop='static'
      onHide={() => {
        setIsShow(false)
        closeButtonAction()
        onHide()
      }}
      dialogClassName={dialogClassName}
      centered={centered}
      size={size}
      style={{ zIndex, ...style }}
      data-testid={testId}
    >
      <ModalBootstrap.Header style={{ backgroundColor: headerBackgroundColor, ...headerStyle, ...styleHeader }}>
        <TitleContainer>
          {IconLeft && <IconLeft />}
          <ModalBootstrap.Title style={titleStyle}>{title}</ModalBootstrap.Title>
        </TitleContainer>
        {closedButton && (
        <ExitButton
          aria-label='fechar'
          onClick={closeButtonAction || handleIsShow}
          disabled={closeButtonDisabled}
        >
          <X />
        </ExitButton>
        )}
      </ModalBootstrap.Header>
      <ModalBootstrap.Body style={{ padding: 0, ...bodyStyle }}>{body}</ModalBootstrap.Body>
    </ModalBootstrap>
  )
}

export default Modal
